import Instance from "../../../../Axios";

// New Actions for the app

const GetCredVeiculosCores = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/veiculosCores`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VEICULOS_CORES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredVeiculosCores;